// src/components/LoginForm.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Updated import
import AuthLayout from '../AuthLayout'; 
import Swal from 'sweetalert2'; // Import SweetAlert2

const LoginForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth(); // Updated to use useAuth hook
  const navigate = useNavigate();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const result = await login(formData.email, formData.password); // Pass email and password separately
      
      if (result.success) {
        // Show success message
        Swal.fire({
          title: 'Login Successful',
          text: 'Welcome back!',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          // Redirect to home page on successful login
          navigate('/');
        });
      } else {
        // Show error message
        Swal.fire({
          title: 'Login Failed',
          text: result.message || 'Please check your credentials and try again',
          icon: 'error',
          confirmButtonText: 'Try Again',
          confirmButtonColor: '#dc3545'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error.message || 'An unexpected error occurred',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <AuthLayout>
      <section id="login-form" className="pt-4 pb-4 ">
        <br /><br /><br /><br />
        <div className="container-xl">
          <div className="row contact_22 mt-4">
            <div className="col-md-4"></div>
            <div className="col-md-8">
              <div className="contact_2l row">
                <div className="col-md-6">
                  <h4 className='text-white text-center'>LOGIN</h4>
                </div>
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="contact_2l1 mt-3 row">
                  <div className="col-md-6">
                    <label className="form-label text-white text-start d-block">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="contact_2l1 mt-3 row">
                  <div className="col-md-6">
                    <label className="form-label text-white text-start d-block">Password</label>
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      minLength="8"
                    />
                  </div>
                </div>

                <div className="contact_2l1 mt-3 row">
                  <div className="col-md-6">
                    <div className='text-white text-end'>
                      <Link to="/forgot-password" className="col_red">Forgot Password?</Link>
                    </div>
                  </div>
                </div>

                <div className="contact_2l1 mt-3 row">
                  <div className="col-md-6">
                    <h6 className="mt-3 mb-0 text-center">
                      <button 
                        className="button" 
                        type="submit" 
                        disabled={loading}
                      >
                        {loading ? 'Logging in...' : 'Login'}
                      </button>
                    </h6>
                    <br />
                    <div className='text-white text-center'>
                      Don't have an account?{' '}
                      <Link to="/signup" className="col_red" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        Sign Up
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <br /><br /><br /><br />
      </section>
    </AuthLayout>
  );
};

export default LoginForm;
